import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  storageInstance;
  private initialization?: Promise<Storage>;

  constructor(public storage: Storage) {}

  async init(): Promise<Storage> {
    if (this.storageInstance) return this.storageInstance;
    if (!this.initialization) {
      this.initialization = this.storage.create().then(storage => {
        this.storageInstance = storage;
        return storage;
      }).catch(error => {
        this.initialization = undefined;
        throw error;
      });
    }
    return this.initialization;
  }

  public async set(key: string, value: any): Promise<any> {
    if (!this.storageInstance) {
      await this.init();
    }
    return this.storageInstance.set(key, value);
  }

  public async get(key: string): Promise<any> {
    if (!this.storageInstance) {
      await this.init();
    }
    return this.storageInstance.get(key);
  }
}
